<template>
  <div class="wd-100p ht-100p">
    <!-- <Header></Header> -->
    <div class="wd-100p ht-100p cr-hei">
      <div class="wd-100p pos-r">
        <div class="wd-100p ht-100vh ov-h bg-white">
          <div class="ht-100p pos-r ov-h bg-2">

            <div class="wd-100p ht-100p pos-r">
              <div class="wd-100p ht-180 bg-hei-05 pos-a bottom-0 zindex-99 dp-flex jus-c" v-animate="{ name: 'bounceInUp', delay: 100}">
                <div @click="clickref('/Vrtual')" class=" ht-60 font-30 bg-hong cr-white dp-flex jus-c pointer"
                :class="mob?'wd-70p':'wd-30p'"
                >Click to Experience</div>
              </div>
              <video id="video-virtual" src="static/media/footage.mp4" class="wd-100p ht-100p" autoplay muted
                webkit-playsinline="true" playsinline="true" x-webkit-airplay="allow" x5-video-player-type="h5"
                x5-video-orientation="portraint" x5-video-player-fullscreen="true" style="object-fit:fill">
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";
// import Header from "@/components/header.vue";
// import Footer from "@/components/footer.vue";

export default {
  components: {
    // Header, Footer,
  },
  data() {
    return {
    };
  },
  methods: {
    clickref(ref) {
      this.pushr(ref);
    },
  },
  created() {
    this.virtualList = config.virtualList;
  },
  mounted() {
    this.$store.dispatch("getMob");
    var that = this;
    // this.playVideo();
    // document.addEventListener('mouseover', function () { that.bgsounds() }, false);
    // document.addEventListener('WeixinJSBridgeReady', function () { that.playVideo() }, false);
    // document.addEventListener('touchstart', function () { that.playVideo() }, false);
  },

  computed: {
    mob() {
      return this.$store.state.mob;
    },
    // playVideo: function () {
    //   var that = this, v = document.getElementById("video-virtual");
    //   v.play();
    //   v.addEventListener("ended", function () {
    //     that.show_video = false;
    //   })
    // },
  },
  beforeDestroy() { },
};
</script>